/**
 * clientId — a unique id for THIS browser tab (one per page load / tab, not
 * per user). Sent on every API request (X-Pidly-Client-Id) and used by the
 * live data-sync to suppress a tab's echo of its OWN writes — while still
 * syncing the SAME user's OTHER tabs (which have different client ids).
 *
 * Module-level (not sessionStorage) so a duplicated tab gets a fresh id rather
 * than inheriting the original's — otherwise the two tabs would suppress each
 * other's updates again.
 */
const CLIENT_ID = `c_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;

export function getClientId() {
  return CLIENT_ID;
}
